import React from 'react';
import _ from 'lodash';
import { Row } from '@mlc/web-ui-toolkit';
import { FieldArray } from 'formik';
import { InvestmentFilterElements } from '../InvestmentFilterElements';
import * as Styled from '../../styled';
import { handleAllSelectionForCheckboxArray } from '../../handleAllSelectionForCheckboxArray';
import GroupFragment from '../../../../containers/GroupFragment/GroupFragment';

interface Props {
	investmentType: string[];
}

const investmentTypes = {
	leftCol: [
		{
			value: 'all',
			label: 'All',
			dataId: InvestmentFilterElements.allInvestmentCheckboxFilterId,
		},
		{
			value: 'superannuation',
			label: 'Super',
			dataId: InvestmentFilterElements.superInvestmentCheckboxFilterId,
		},
		{
			value: 'retirement',
			label: 'Retirement',
			dataId: InvestmentFilterElements.retirementInvestmentCheckboxFilterId,
		},
	],
	rightCol: [
		{
			value: 'investment',
			label: 'Investment',
			dataId: InvestmentFilterElements.investmentInvestmentCheckboxFilterId,
		},
		{
			value: 'business super',
			label: 'Business super',
			dataId: InvestmentFilterElements.businessSuperInvestmentCheckboxFilterId,
		},
	],
};

const InvestmentTypeFilter = (props: Props) => {
	return (
		<React.Fragment>
			<Styled.FilterLabel label="Investment type">
				<GroupFragment>
					<FieldArray
						name="investmentType"
						render={arrayHelpers => (
							<Row>
								<Styled.CheckboxSubCol md="6" sm="12">
									{_.map(investmentTypes.leftCol, type => (
										<Styled.FilterCheckbox
											key={type.value}
											name="investmentType"
											label={type.label}
											value={type.value}
											data-id={type.dataId}
											checked={props.investmentType.includes(type.value)}
											onChange={(e: any) => {
												handleAllSelectionForCheckboxArray(
													e,
													type,
													arrayHelpers,
													props.investmentType
												);
											}}
										/>
									))}
								</Styled.CheckboxSubCol>
								<Styled.CheckboxSubCol md="6" sm="12">
									{_.map(investmentTypes.rightCol, type => (
										<Styled.FilterCheckbox
											key={type.value}
											name="investmentType"
											label={type.label}
											value={type.value}
											data-id={type.dataId}
											checked={_.includes(props.investmentType, type.value)}
											onChange={(e: any) => {
												handleAllSelectionForCheckboxArray(
													e,
													type,
													arrayHelpers,
													props.investmentType
												);
											}}
										/>
									))}
								</Styled.CheckboxSubCol>
							</Row>
						)}
					/>
				</GroupFragment>
			</Styled.FilterLabel>
		</React.Fragment>
	);
};
export default InvestmentTypeFilter;
